import type { SiteSettings } from "@/mocks/adminData";

const DEFAULT_COLLAB_IMAGE = "https://www.au2p0rz.vip/assets/collab-banner-pc-CKsuST2e.webp";

interface CollabBannerProps {
  settings: SiteSettings;
}

export default function CollabBanner({ settings }: CollabBannerProps) {
  const collabImage = settings.collab_image || DEFAULT_COLLAB_IMAGE;

  return (
    <div className="w-full" style={{ background: "#eef2f7" }}>
      <img
        src={collabImage}
        alt="寻求代投资源合作"
        className="w-full block"
        style={{ display: "block" }}
        loading="lazy"
      />
    </div>
  );
}